module.exports = "<p>\r\n  valideprecompte works!\r\n</p>\r\n"